import React from 'react';
import { Spin } from 'antd';
import styles from './asset/SessionValidationOverlay.module.scss';
import MessageConstant from '../../utils/Constant/MessageConstant';

const SessionValidationOverlay = ({ message = MessageConstant.SESSION_EXPIRED_GENERIC.replace('Please login again.', 'Redirecting to login...') }) => {
    return (
        <div className={styles.sessionOverlay}>
            <div className={styles.sessionOverlayContent}>
                <Spin size="large" />
                <p className={styles.sessionOverlayMessage}>{message}</p>
            </div>
        </div>
    );
};

export default SessionValidationOverlay;
